import { useHotelFiltersForm } from "@website/accommodation-ui/hotel-filter/hotel-filter.hook";
import { UseHotelFiltersFormProperties } from "@website/accommodation-ui/hotel-filter/hotel-filter.types";
import { deepCompare } from "@website/utils/deep-compare";
import { Filters } from "@website/widget/filter";
import { FC, memo } from "react";

const Component: FC<UseHotelFiltersFormProperties> = (properties) => {
  const { filtersSchema, mapFilterProps, trackingCallback } = properties;
  const { resetButtonProps, title, footerProps } =
    useHotelFiltersForm(properties);
  return (
    <Filters
      mapFilterProps={mapFilterProps}
      trackingCallback={trackingCallback}
      resetButtonProps={resetButtonProps}
      schema={filtersSchema}
      title={title}
      {...footerProps}
    />
  );
};

export const HotelFilter = memo(Component, deepCompare);
